import { useQuery } from '@tanstack/react-query';
import { publicApi } from '../api/endpoints/public';
import { PASSWORD_POLICY_FALLBACK, type PasswordPolicy } from '../lib/passwordRules';

/**
 * Política de complejidad de contraseña efectiva del backend (`GET /public/password-policy`,
 * DEC-RBAC-052). El front la REFLEJA, no la define.
 *
 * NUNCA rompe la pantalla: mientras carga o si la llamada falla (endpoint caído o todavía no
 * desplegado), `policy` cae al `PASSWORD_POLICY_FALLBACK` (= los valores hardcodeados previos:
 * minLength 12 + require* todos). Cache larga porque la policy cambia con un deploy, no en runtime.
 */
export function usePasswordPolicy(): {
    policy: PasswordPolicy;
    isLoading: boolean;
    isError: boolean;
} {
    const query = useQuery({
        queryKey: ['public', 'password-policy'],
        queryFn: () => publicApi.getPasswordPolicy(),
        // La policy es global y cambia solo con un deploy del lambda → no la re-pedimos por sesión.
        staleTime: Infinity,
        gcTime: Infinity,
        retry: false,
    });

    return {
        policy: query.data ?? PASSWORD_POLICY_FALLBACK,
        isLoading: query.isLoading,
        isError: query.isError,
    };
}
